import { useEffect, useState } from 'react';
import { ContactRepModalDetails, CustomEventName } from '@mb/lib';
import { useDispatch } from 'react-redux';
import { getRepresentatives } from '../api/representatives';

export const useContactRepBehaviour = () => {
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalDetails, setModalDetails] = useState<
    ContactRepModalDetails | undefined
  >(undefined);

  const handleOpenModal = ({ detail }: CustomEvent<ContactRepModalDetails>) => {
    dispatch(
      getRepresentatives(detail.data.product_id, detail.data.manufacturer_id),
    );
    setModalDetails(detail);
    setIsModalOpen(true);
  };

  useEffect(() => {
    window.addEventListener(
      CustomEventName.OPEN_CONTACT_REP_MODAL_V2,
      handleOpenModal,
    );
    return () => {
      window.removeEventListener(
        CustomEventName.OPEN_CONTACT_REP_MODAL_V2,
        handleOpenModal,
      );
    };
  }, []);

  return { isModalOpen, setIsModalOpen, modalDetails };
};
